import { useMemo } from 'react';
import { HubBasePage } from '../../../../../types';
import {
  DiscoveryContentTypes,
  InformaMetaTagPageType,
} from '../../../../../constants';
import { useRootSelector } from '../../../../../store/hooks';
import { selectAudienceHubPage } from '../../store/features/page';
import { selectAudienceHubOptions } from '../../store/features/options';
import {
  selectHubDiscoveryFacets,
  selectHubDiscoverySiteRecord,
  DiscoverySite,
  HubPageNames,
  SortTypes,
} from '../../../../../store/features/discovery';
import PageLayout from '../../layouts/PageLayout';
import { MetaTags } from '../../../shared/MetaTags';
import { SiteCard } from '../../../shared/productFilter/cards';
import { AggregatedProductPage } from '../../../shared/siteBuilder/AggregatedProductPage';
import { getCurrentEpochDayByTimezone } from '../../../shared/helpers';
import { selectUserTimezone } from '../../../../../store/commonDucks/userContext';

export function Events() {
  const {
    data: {
      page: {
        details: { title, description, metaDescription, searchQueryData },
      },
      header: {
        headerNavBar: { brandLogo },
      },
    },
  } = useRootSelector(selectAudienceHubPage<HubBasePage>());
  const {
    data: { name: hubName, subBrandName: brandName, l2Topic: topicName },
  } = useRootSelector(selectAudienceHubOptions);
  const facets = useRootSelector(selectHubDiscoveryFacets);
  const record = useRootSelector((state) =>
    selectHubDiscoverySiteRecord(state, DiscoveryContentTypes.EVENT),
  );
  const userTimezone = useRootSelector(selectUserTimezone);

  const heading = title || 'Events';

  const defaultValues = useMemo(
    () => ({
      deliveryType: [],
      subBrands: [brandName],
      sectors: [],
      topics: [],
      month: [],
      location: [],
      availableSubBrands: [brandName],
      mainFilterTopic: topicName,
      requestedSortType: SortTypes.FEATURED,
      page: 1,
      count: 20,
      searchInput: '',
      type: [DiscoveryContentTypes.EVENT],
      currentDateEpochDay: getCurrentEpochDayByTimezone(userTimezone),
    }),
    [brandName, topicName, userTimezone],
  );

  return (
    <PageLayout>
      <MetaTags
        title={heading}
        titleSuffix={hubName}
        description={metaDescription}
        thumbnail={brandLogo?.path}
        informaPageId={HubPageNames.events}
        informaPageType={InformaMetaTagPageType.BasePage}
      />
      <AggregatedProductPage<DiscoverySite>
        pageName={HubPageNames.events}
        contentType={DiscoveryContentTypes.EVENT}
        title={heading}
        subtitle={description}
        facets={facets}
        record={record}
        renderProduct={(product) => <SiteCard data={product} cardType="list" />}
        defaultValues={defaultValues}
        searchQueryData={searchQueryData}
      />
    </PageLayout>
  );
}
